import { useEffect, useState } from 'react';
import type { WindowWithWorker } from '../TextParticles.types';
import workerScriptUrl from '../worker/worker.umd.js?resource';

type WorkerInstance = Worker | null;

const createWorkerBlobUrl = (workerUrl: string) => {
  const blob = new Blob([`importScripts('${workerUrl}');`], {
    type: 'application/javascript',
  });
  return URL.createObjectURL(blob);
};

export const useWebWorker = (): WorkerInstance => {
  const [worker, setWorker] = useState<WorkerInstance>(null);

  useEffect(() => {
    const windowWithWorker = window as WindowWithWorker;

    const initializeWorker = () => {
      try {
        if (windowWithWorker.particlesAnimationWorker) {
          setWorker(windowWithWorker.particlesAnimationWorker);
          return;
        }

        const newWorker = new Worker(createWorkerBlobUrl(workerScriptUrl));

        windowWithWorker.particlesAnimationWorker = newWorker;
        setWorker(newWorker);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(
          '[TextParticles]: failed to initialize web worker:',
          error,
        );
        setWorker(null);
      }
    };

    initializeWorker();
  }, []);

  return worker;
};
